define([
	"dojo/_base/declare",
	"csi/action/EditController",
	"csi/page",
	"csi/state/rootStore",
	"csi/xml"
], function(declare,EditController,page,{ routerStore },xml) {

	return declare(EditController, {
		toWriter: function() {
			var	call = this.inherited(arguments);
			call.addParameter("SampleURL", xml.ATTR_REF, routerStore.locationUrl);
			return call;
		},

		postProcessSuccess: function() {
			page.refreshRootView();
		}
	});
});